module.exports = __webpack_public_path__ + "img/5-1.439402e6.svg";